import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ClientCheckInAccessStatus } from '@fitness-force/enum';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'fitness-force-check-in-status',
  templateUrl: './check-in-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe, NgClass],
})
export class CheckInStatusComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  constructor() {}

  ngOnInit(): void {}

  setCheckInStatus(status: any) {
    return ClientCheckInAccessStatus[
      status as keyof typeof ClientCheckInAccessStatus
    ].toString();
  }
}
